import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Target, Trophy, Music, Bell } from "lucide-react";
import { childApi } from "../lib/api";

const KIND_ICONS = { quest: Target, achievement: Trophy, mastery: Music };

export default function ChildNotices() {
  const [rows, setRows] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    childApi.get("/child/notifications").then((r) => {
      setRows(r.data.notifications);
      childApi.post("/child/notifications/read");
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7EE]" data-testid="notices-page">
      <header className="bg-[#0B192C] text-[#FAF7EE] px-5 py-5">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <button onClick={() => navigate("/play/home")} aria-label="Back" data-testid="back-btn"
            className="p-2.5 rounded-full hover:bg-white/10 min-h-[48px] min-w-[48px] flex items-center justify-center">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="font-display font-bold text-xl">Notices</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-8 space-y-3">
        {!rows ? null : rows.length === 0 ? (
          <p className="text-sm text-[#566270]" data-testid="no-notices">Nothing new yet.</p>
        ) : rows.map((n) => {
          const Icon = KIND_ICONS[n.kind] || Bell;
          return (
            <div key={n.id} className={`rounded-2xl border p-4 flex gap-3 ${n.read ? "bg-white border-[#E5DEC9]" : "bg-[#F6EED8] border-[#C69B3D]/50"}`}
              data-testid={`notice-${n.id}`}>
              <Icon className="w-5 h-5 text-[#C69B3D] shrink-0 mt-0.5" aria-hidden />
              <div>
                <p className="font-bold text-sm text-[#0B192C]">{n.title}</p>
                <p className="text-sm text-[#566270]">{n.body}</p>
                <p className="text-[10px] text-[#566270]/70 mt-1">
                  {new Date(n.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}
                </p>
              </div>
            </div>
          );
        })}
      </main>
    </div>
  );
}
